import { render, staticRenderFns } from "./image-select.vue?vue&type=template&id=6b0239e7&scoped=true"
import script from "./image-select.vue?vue&type=script&lang=js"
export * from "./image-select.vue?vue&type=script&lang=js"
import style0 from "./image-select.vue?vue&type=style&index=0&id=6b0239e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0239e7",
  null
  
)

export default component.exports